import React from 'react';
import { Avatar as AntdAvatar, AvatarProps } from 'antd';
import styled from '@emotion/styled';

import { ReactComponent as CompanyPlaceholder } from 'assets/images/placeholders/avatar-company.svg';
import { ReactComponent as AvatarPlaceHolder } from 'assets/images/placeholders/user-profile.svg';

const StyledAvatar = styled(AntdAvatar, {
  shouldForwardProp: (propName) => {
    if (propName === 'placeholder') return false;
    return true;
  }
})`
  background: #fff;
  .ant-avatar-string {
    transform: ${(props: any) => {
      if (props.placeholder) {
        return 'translateX(-50%) !important';
      }
      return '';
    }};
  }
` as any;

enum DefaultPlaceHolder {
  COMPANY = 0,
  PROFILE = 1
}
export const PLACE_HOLDERS = {
  COMPANY: <CompanyPlaceholder />,
  USER_PROFILE: <AvatarPlaceHolder />
};
type Props = Partial<AvatarProps> & {
  placeholder?: DefaultPlaceHolder | React.ReactNode;
  ghost?: boolean;
};
const Avatar = ({ placeholder, ...props }: Props) => {
  return (
    <StyledAvatar placeholder={placeholder} {...props}>
      {placeholder}
    </StyledAvatar>
  );
};
Avatar.PLACE_HOLDERS = PLACE_HOLDERS;
export default Avatar;
